import { injectable } from "tsyringe";
import client from "api/client";
import { SUPPORT_FEATURE } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { IPackageLookupRepository } from "../domain/repositories/IPackageLookupRepository";
import { PackageLookupRequestModel } from "./model/PackageLookupRequestModel";
import { PackageLookupResponseModel } from "./model/PackageLookupResponseModel";

@injectable()
export class PackageLookupImpl implements IPackageLookupRepository {
  async viewPlan(
    params: PackageLookupRequestModel
  ): Promise<BaseApiResponseModel<PackageLookupResponseModel>> {
    return await client?.get(SUPPORT_FEATURE.VIEW_PLAN, params);
  }
}
